module.exports = __webpack_public_path__ + "static/media/noselected.32b52fe5.svg";